module.exports = __webpack_public_path__ + "static/img/email.c1d34866.svg";